import { useQuery } from "react-query";

import * as Api from "../api";
import * as Constants from "../constants";
import * as Mappers from "../mappers";
import get from "lodash/get";

const useSingle = ({ id }) => {
    const initialData = { item: Mappers.ServiceRegister(), };

    const { data = initialData, ...args } = useQuery(
        [Constants.ENTITY, "single", id],
        async () => {
            const { data } = await Api.Single({id});

            const item = Mappers.ServiceRegister(get(data, 'data'));

            return { item };
        },
        { initialData, keepPreviousData: true, enabled: !!id }
    );

    return { ...data, ...args };
};

export default useSingle;
